
export default {
  props:['text']
}
